import { Controller } from "@hotwired/stimulus";

// Switches an icon to a small form and back (see `mia_field` in EventsHelper).
// The form is submitted by Turbo; the answer replaces the whole field.
export default class extends Controller {
  static targets = ["display", "form", "input"];

  edit() {
    this.displayTarget.hidden = true;
    this.formTarget.hidden = false;
    this.inputTarget.focus();
  }

  cancel() {
    this.formTarget.reset();
    this.formTarget.hidden = true;
    this.displayTarget.hidden = false;
  }
}
